module.exports = __webpack_public_path__ + "static/daily-ui-9530273cea96f3c3615e3d9d6396c952.png";